import { Feature } from '@givz/core-client';
import { mapKeys } from 'lodash';
import { atom, selector } from 'recoil';
import { MapGivzFeatures } from 'src/types';

export const featuresState = atom<Feature[]>({
  default: [],
  key: 'featuresState',
});

export const mappedGivzFeaturesSelector = selector<MapGivzFeatures | undefined>(
  {
    get: ({ get }) => {
      const features = get(featuresState);
      return mapKeys(features, 'key');
    },
    key: 'mappedGivzFeaturesSelector',
  },
);
